import { Person } from '@/types/person';

type arrayNameType = 'emails' | 'phones' | 'addresses';

const getIndexForDefault = (person: Person, arrayName: arrayNameType): number => {
  /**
   * Returns the index of the array object that is marked as default: true
   */
  const defaultIndex = 0;
  const arr = person[arrayName];

  if (arr.length) {
    const defaultedRecord = arr.find((record) => {
      return record['default'];
    });

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return defaultedRecord ? arr.indexOf(defaultedRecord) : defaultIndex;
  }

  return defaultIndex;
};

export default getIndexForDefault;
